import React from 'react';

export function PaginationSkeleton() {
  return (
    <div className="flex justify-between items-center w-full will-change-opacity">
      {/* Entries Info */}
      <div className="h-5 w-48 bg-gray-200 rounded-md animate-pulse"></div>

      {/* Pagination Controls */}
      <div className="flex items-center gap-2">
        {/* Previous Button */}
        <div className="h-8 w-8 bg-gray-200 rounded-md animate-pulse"></div>

        {/* Page Numbers */}
        <div className="flex gap-1">
          {[...Array(3)].map((_, index) => (
            <div
              key={index}
              className="h-8 w-8 bg-gray-200 rounded-md animate-pulse"
              style={{ animationDelay: `${index * 0.1}s` }}
            ></div>
          ))}
        </div>

        {/* Next Button */}
        <div className="h-8 w-8 bg-gray-200 rounded-md animate-pulse"></div>
      </div>
    </div>
  );
}
